module.exports = __webpack_public_path__ + "img/H000110_fishred.61ca605b.png";